import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { ToastrService } from 'ngx-toastr';
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-tournament-payment',
  templateUrl: './tournament-payment.component.html',
  styleUrls: ['./tournament-payment.component.scss']
})
export class TournamentPaymentComponent implements OnInit {
  public isLoading: boolean = false;
  public tournamentID = '';
  public selectedRecordForEdit: any = '';

  paymentListingData?;


  public totalRecords = 0;
  currentPage: number = 1;
  totalPages: number = 1;
  pageLimit: number = 10
  totalPageLimits: number[] = [5, 10, 20]

  @ViewChild('addNewPaymentModal', { static: false }) public addNewPaymentModal: ModalDirective;
  @ViewChild('removePaymentModal', { static: false }) public removePaymentModal: ModalDirective;


  paymentDetails: FormGroup
  constructor(
    private fb: FormBuilder,
    private localInterfaceSrv: LocalInterfaceService,
    private toastr: ToastrService,
    private validationSrv: ValidationService,
    public router: Router,
    public route: ActivatedRoute,
    private elementRef: ElementRef
  ) {
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess().then(async () => {
      // this.createForm();
      const tournamentID = this.route.snapshot.params['id'];
      this.tournamentID = tournamentID
      this.isLoading = true
      await this.loadPaymentListingData();
      this.isLoading = false
    });
    // this.createForm();
  }

  scrollToTop() {
    const htmlElement = this.elementRef.nativeElement.ownerDocument.documentElement;
    htmlElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  loadPaymentListingData = (updatedPage?, updatedLimit?) => {
    const obj = {
      // status: "current",

      page: updatedPage || this.currentPage,
      limit: updatedLimit || this.pageLimit,
    }

    const params = new URLSearchParams(obj as any);
    const queryString = params.toString();
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.tournamentID

      this.localInterfaceSrv.getTournamentPaymentList(queryString, this.tournamentID)
        .then(async res => {

          this.totalPages = res.data.count
          if (this.totalRecords <= 0) {
            this.totalRecords = res.data.count
          }

          this.paymentListingData = { content: res.data.content, count: this.totalRecords };
          this.isLoading = false;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          console.log(err);

        })
        .finally(() => {
          this.isLoading = false
        });
    });
  }

  onPaginationChange = async (page: number) => {
    this.currentPage = page;
    // this.filterQuery=""
    this.scrollToTop()

    await this.loadPaymentListingData(page)
  }

  onPageChange = async (updatedPage) => {
    if (updatedPage === this.pageLimit)
      return

    this.pageLimit = updatedPage
    this.currentPage = 1;
    await this.loadPaymentListingData(1, updatedPage)
  }

  // createForm(selectedRecord?): void {
  //   this.paymentDetails = this.fb.group({
  //     payment: [selectedRecord ? selectedRecord.payment : "", Validators.required],
  //     labelEn: [selectedRecord ? selectedRecord.labelEn : "", Validators.required],
  //     labelAr: [selectedRecord ? selectedRecord.labelAr : "", Validators.required],
  //     ccy: [selectedRecord ? selectedRecord.ccy : "", Validators.required],
  //     totalSeats: [selectedRecord ? selectedRecord.totalSeats : "", [Validators.required, Validators.pattern(/^\d+$/)],],
  //     availableSeats: [selectedRecord ? selectedRecord.availableSeats : "", [Validators.required, Validators.pattern(/^\d+$/)],],
  //     price: [selectedRecord ? selectedRecord.price : "", [Validators.required, Validators.pattern(/^\d+$/)],],
  //     sort: [selectedRecord ? selectedRecord.sort : "", [Validators.required, Validators.pattern(/^\d+$/)],],
  //   });
  // }

  // addPayment = () => {
  //   this.createForm();
  //   this.addNewPaymentModal.show();

  // }

  // onEditPaymentClick = (item) => {
  //   console.log('Item', item);
  //   this.selectedRecordForEdit = item
  //   this.createForm(item);
  //   this.addNewPaymentModal.show();
  // }

  // onSubmit(): void {

  //   if (this.paymentDetails.valid) {
  //     console.log(this.paymentDetails);
  //     // if (this.selectedRecordForEdit)
  //     //   this.updateTournamentPaymentData()
  //     // else
  //     this.saveTournamentPaymentData();


  //   } else {
  //     // Form is invalid, show error messages
  //     this.markFormGroupTouched(this.paymentDetails);
  //   }
  // }


  // saveTournamentPaymentData = () => {
  //   return new Promise<any>(async (resolve, reject) => {
  //     this.isLoading = true;
  //     this.localInterfaceSrv
  //       .saveTournamentPayment(this.paymentDetails.value, this.tournamentID)
  //       .then(async (res) => {
  //         this.toastr.success('Tournament Payment saved successfully');
  //         this.addNewPaymentModal.hide();
  //         await this.loadPaymentListingData();

  //         this.isLoading = false;

  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //         console.log(err);
  //         this.toastr.error(err.description, 'Error');
  //       })
  //       .finally(() => {
  //         this.isLoading = false;
  //       });
  //   });
  // };

  // updateTournamentPaymentData = () => {
  //   return new Promise<any>(async (resolve, reject) => {
  //     this.isLoading = true;
  //     this.localInterfaceSrv
  //       .updateTournamentPayment(this.paymentDetails.value, this.tournamentID, this.selectedRecordForEdit.id)
  //       .then(async (res) => {

  //         this.toastr.success('Tournament Payment Updated successfully');
  //         this.addNewPaymentModal.hide();
  //         await this.loadPaymentListingData(this.pageLimit, this.currentPage);

  //         this.isLoading = false;

  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //         console.log(err);
  //         this.toastr.error(err.description, 'Error');
  //       })
  //       .finally(() => {
  //         this.isLoading = false;
  //       });
  //   });
  // };

  // markFormGroupTouched(formGroup: FormGroup): void {
  //   (Object as any).values(formGroup.controls).forEach(control => {
  //     control.markAsTouched();

  //     if (control instanceof FormGroup) {
  //       this.markFormGroupTouched(control);
  //     }
  //   });
  // }

  // removePayment = (selectedRecordForDelete) => {

  //   return new Promise<any>(async (resolve, reject) => {
  //     this.isLoading = true;

  //     this.localInterfaceSrv
  //       .deleteTournamentPayment(this.tournamentID, selectedRecordForDelete)
  //       .then(async (res) => {

  //         this.toastr.success('Tournament Payment Deleted successfully');
  //         this.removePaymentModal.hide();
  //         await this.loadPaymentListingData();

  //         this.isLoading = false;

  //         resolve(res);
  //       })
  //       .catch((err) => {
  //         reject(err);
  //         console.log(err);
  //         this.toastr.error(err.description, 'Error');
  //       })
  //       .finally(() => {
  //         this.isLoading = false;
  //       });
  //   });
  // }

}
